import { render, staticRenderFns } from "./TemplateTextBlock.vue?vue&type=template&id=2c00a95f&scoped=true&"
import script from "./TemplateTextBlock.vue?vue&type=script&lang=js&"
export * from "./TemplateTextBlock.vue?vue&type=script&lang=js&"
import style0 from "./TemplateTextBlock.vue?vue&type=style&index=0&id=2c00a95f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c00a95f",
  null
  
)

export default component.exports